// @flow
import * as React from 'react';
import { Portal, UserAvatar } from '../../../shared';
import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import moment from 'moment';
import { useMemo } from 'react';
import { ShowedUpToggle } from '../../showed-up-toggle';
import { XIcon } from '@phosphor-icons/react';
import { RequiredActionProps } from '../types';

export const NoShowRequiredAction = ({item, onResolved, onHide}: RequiredActionProps) => {
  const details = useMemo(() => JSON.parse(item.detailsJson), [item.detailsJson]);

  return (
    <Portal sx={{'&:hover': {border: '1px solid #d0d5e1' }, transition: 'all .3s', mb: 2, background: '#FFF', minWidth: 366 }}>
      <Stack gap={2} direction={'row'} alignItems={'center'} justifyContent={'space-between'}
             sx={{background: 'linear-gradient(137deg, rgba(247, 231, 186, 1) 0%, rgb(240 255 231) 70%)'}} p={'8px 12px'}>
        <Typography flex={1} variant={'h5'} fontWeight={500} noWrap>
          Attendance is unconfirmed
        </Typography>

        <Typography variant={'caption'} align={'right'}>
          {moment(item.createdAt).format('L H:mm')}
        </Typography>

        {onHide && <ButtonBase onClick={onHide}>
          <XIcon size={16} color={'#1c434f'} weight={'bold'} />
        </ButtonBase>}
      </Stack>

      <Stack direction={'row'} alignItems={'center'} p={'8px 8px 0'} justifyContent={'space-between'}>
        <Typography flex={1} variant={'body2'}>
          Did this client show up for the<br /> appointment at: <b>{moment(details.startTime).format('L H:mm')}</b>?
        </Typography>

        <ShowedUpToggle appUrl={details.uri} onChange={onResolved} clientId={details.invitee?.clientId} />
      </Stack>

      <Box my={1}>
        <ButtonBase onClick={() => window.open(`/${'client'}/${details.invitee?.clientId}`, '_blank')}
                    sx={{
                      padding: '4px 8px',
                      borderRadius: '8px'
                    }}
        >
          <UserAvatar size={32}
                      fontSize={13}
                      showEmail
                      email={details.invitee?.email}
                      name={details.invitee?.name} />
        </ButtonBase>
      </Box>
    </Portal>
  );
};
